<script>
  export let overline;
  export let title;
  export let step;

  import IntersectionObserver from "svelte-intersection-observer";
  let intersecting;
  let element;

  import { selectedDistrict } from "@stores/userData.js";
  import { fly } from "svelte/transition";
  import navigateToHash from "@helpers/navigateToHash.js";
</script>

<IntersectionObserver {element} bind:intersecting>
  <div
    class="step {intersecting ? 'active' : 'inactive'}"
    bind:this={element}
    id="share-step-{step}"
  >
    <p class="big-number">{overline}</p>
    <h2 class="section-subtitle">{title}</h2>
    {#if step == 2 && !$selectedDistrict}
      <span
        transition:fly={{ x: 30 }}
        class="go-to-houston"
        on:click={() => {
          navigateToHash("share-step-1", 0);
        }}
      >
        Live in Houston? Find your City Council member above!
      </span>
    {/if}
    <slot />
  </div>
</IntersectionObserver>

<style>
  .step {
    margin: 10rem auto 0 auto;
    width: 100%;
    max-width: 1068px;
    transition: 500ms ease;
    scroll-margin-top: calc(var(--nav-height) + 1rem);
    position: relative;
  }

  .section-subtitle {
    font-size: 2.15rem;
    margin-bottom: 2rem;
    text-align: center;
    font-weight: 300;
    line-height: 1.2;
    color: rgba(var(--text-color-rgb), 0.65);
  }

  :global(.step.inactive) {
    opacity: 0.5;
  }

  .big-number {
    text-align: center;
    font-size: 3rem;
    margin-bottom: 0.25rem;
    font-family: var(--font-serif);
    text-transform: uppercase;
    letter-spacing: -0.1rem;
    /* font-style: italic; */
  }

  .go-to-houston {
    position: absolute;
    right: 0;
    top: -0.5rem;
    width: 200px;
    text-align: center;
    background: white;
    padding: 0.5rem;
    outline: 3px solid var(--accent-color);
    transform: rotate(10deg);
    cursor: pointer;
    font-weight: 300;
    line-height: 1.15;
  }

  .go-to-houston::before {
    background-image: url("/images/emojis/point-up.png");
    position: absolute;
    left: -15px;
    top: -20px;
    width: 30px;
    height: 30px;
    background-repeat: no-repeat;
    background-size: 30px;
    content: "";
  }

  @media screen and (max-width: 768px) {
    .go-to-houston {
      top: -2rem;
    }
  }

  @media screen and (max-width: 568px) {
    .go-to-houston {
      top: -3rem;
      font-size: 0.85rem;
      outline: 2px solid var(--accent-color);
    }
  }
</style>
